import { Subject } from "rxjs";
import type { JobAccessDialogRequest } from "./JobAccessDialog";

/** Emit a request to open the Job Access dialog, or undefined to close it.
 *  Kept out of the .tsx so JobAccessDialog exports only its component
 *  (a React Fast Refresh requirement). */
export const showJobAccessDialog = new Subject<
  JobAccessDialogRequest | undefined
>();

/** Convenience function so callers don't have to import Subject. */
export function openJobAccessDialog(req: JobAccessDialogRequest): void {
  showJobAccessDialog.next(req);
}
